import { Input, message } from 'antd';
import { useContext, useState, useMemo, useEffect, useRef } from 'react';
import { GenerateContext } from '../../../hooks/GenerateContext';
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { Button } from 'antd';
import PromptIcon from '@assets/images/svgIcon/promptIcon.svg'
import { RESOURCE_PARAMS, RESOURCE_TYPE } from '@utils/CONST'
import API from '@api/api';
import eventBus from '@utils/eventBus';

const { TextArea } = Input;

const PosetryonPrompt = (props) => {
    const { isModal, setDesc, desc } = props
    const { prompts, setPrompts, inputImage, shouldSkipAlgoPrompt, setShouldSkipAlgoPrompt } = useContext(GenerateContext)
    const [promptLoading, setPromptLoading] = useState(false)
    const [isCollected, setIsCollected] = useState(false)
    const lastPromptRequestId = useRef(0)
    const placeholderList = ['请描述姿势，例如“微微侧身”', '请描述姿势，例如“轻微抬起右脚”', '请描述姿势，例如“抬手抚摸秀发”', '请描述姿势，例如“换个姿势”']

    useEffect(() => {
        if (shouldSkipAlgoPrompt) {
            setShouldSkipAlgoPrompt(false)
            return
        }
        if (inputImage && !isModal) {
            getAlgoPrompt()
        }
    }, [inputImage, isModal])

    const getAlgoPrompt = async () => {
        if (!inputImage) {
            message.warning('请先上传输入图')
            return
        }
        const requestId = ++lastPromptRequestId.current
        setPromptLoading(true)
        API.getAlgoPrompt({
            images: [inputImage],
            modelImage: '',
            mode: 4
        }).then(res => {
            if (requestId !== lastPromptRequestId.current) return
            if (res?.code == 0) {
                const val = res.data || []
                setPromptsMemo(val)
            } else {
                throw new Error(res.message)
            }
        }).catch(err => {
            if (requestId !== lastPromptRequestId.current) return
            message.error(err.message)
        }).finally(() => {
            if (requestId === lastPromptRequestId.current) {
                setPromptLoading(false)
            }
        })
    }

    const promptMemo = useMemo(() => {
        if (desc && desc.length) {
            return desc
        } else {
            return prompts
        }
    }, [desc, prompts])

    useEffect(() => {
        setIsCollected(false)
    }, [promptMemo])

    const setPromptsMemo = useMemo(() => {
        if (setDesc) {
            return setDesc
        } else {
            return setPrompts
        }
    }, [setPrompts, setDesc])

    const handleAddPrompt = async () => {
        if (isCollected) return
        if (!promptMemo.some(item => item?.trim())) {
            message.error('请输入至少一个姿势描述')
            return
        }
        const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.POSTRYON_PROMPT] }
        const res2 = await API.saveCustomMaterialv2({
            ...params,
            image: 'none',
            attr: {
                title: '未命名标题',
                prompts: promptMemo
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        setIsCollected(true)
        eventBus.emit('updatePoseTryonPrompt')
        message.success('收藏成功')
    }


    const totalLength = useMemo(() => {
        return promptMemo.reduce((acc, curr) => acc + (curr ? curr.length : 0), 0)
    }, [promptMemo])

    return (
        <div className={styles.posetryonPrompt}>
            {
                Array.from({ length: 4 }).map((_, index) => {
                    const currentLength = promptMemo[index] ? promptMemo[index].length : 0
                    const maxLength = 800 - (totalLength - currentLength)

                    return (
                        <div className={styles.posetryonPromptItem} key={index}>
                            <span className={styles.itemTitle}>姿势{index + 1}</span>
                            <TextArea
                                value={promptMemo[index]}
                                maxLength={maxLength}
                                onChange={e => {
                                    const newPrompts = Array.from({ length: 4 }).map((_, i) => i === index ? e.target.value : (promptMemo[i] || ''))
                                    setPromptsMemo(newPrompts)
                                }}
                                placeholder={placeholderList[index]}
                                autoSize={{ minRows: 2, maxRows: 4 }}
                            />
                        </div>
                    )
                })
            }
            <div className={styles.posetryonPromptBottom}>
                <span>
                    <Iconfont
                        className={styles.Icon}
                        type="icon-DeleteOutlined"
                        onClick={() => {
                            lastPromptRequestId.current = 0
                            setPromptsMemo(['', '', '', ''])
                        }}
                    />
                    {!isModal &&
                        <Iconfont
                            onClick={handleAddPrompt}
                            className={styles.Icon}
                            style={isCollected ? { color: '#FFBC3F' } : {}}
                            type={isCollected ? "icon-StarFilled" : "icon-StarOutlined"} />}
                    {totalLength > 0 && <span>{totalLength} / 800</span>}
                </span>
                {
                    !isModal && <Button
                        loading={promptLoading}
                        className={styles.smartPromptBtn}
                        onClick={getAlgoPrompt}
                    >
                        {!promptLoading && <img style={{ width: 16 }} src={PromptIcon} alt="" />}
                        智能提示词</Button>
                }


            </div>

        </div>
    )
}

export default PosetryonPrompt;